import {FormGroup} from "@angular/forms";

export class ShowableFormGroup{
  private details: boolean = false;

  public constructor(public form: FormGroup) {

  }

  public toggle(){
    this.details = !this.details;
  }

  public show(){
    this.details = true;
  }

  public hide(){
    this.details = false;
  }

  public get isshown(){
    return this.details;
  }
}
